import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Documents from "containers/document/category-tree/tree-container";
import DownloadHistoryTab from "containers/user-profile/download-history-tab";
import OnboardingDocuments from "containers/user-profile/onboarding-documents";
import { btnLinkCls } from "components/tw/classes";

interface ProfileDocumentsSectionProps {
  companyId: string;
  userId: string;
  /** The address segment that opened the section; /downloads opens it with the download history shown. */
  segment: string | undefined;
}

/** The person's documents tree, their hiring documents and, on request, the download history. */
export default function ProfileDocumentsSection({
  companyId,
  userId,
  segment,
}: ProfileDocumentsSectionProps) {
  const { t } = useTranslation();
  const [showDownloads, setShowDownloads] = useState(segment === "downloads");

  useEffect(() => {
    setShowDownloads(segment === "downloads");
  }, [segment]);

  return (
    <div className="flex flex-col gap-8">
      <Documents userId={userId} source="profile" />

      <section>
        <h2 className="mb-3 text-lg font-semibold text-gray-900">
          {t("onboarding_documents")}
        </h2>
        <OnboardingDocuments companyId={companyId} userId={userId} />
      </section>

      {/* On the /downloads address the history is what the person came for: on a phone it comes
          first instead of sitting under the tree and the lists. */}
      <section className={segment === "downloads" ? "max-md:order-first" : undefined}>
        <button
          type="button"
          className={btnLinkCls}
          aria-expanded={showDownloads}
          onClick={() => setShowDownloads((shown) => !shown)}
        >
          {t("cabinet_download_history")}
        </button>
        {showDownloads && (
          <div className="mt-3">
            <DownloadHistoryTab companyId={companyId} userId={userId} />
          </div>
        )}
      </section>
    </div>
  );
}
